import React from "react";
import { OrdersPageBase } from "../components/orders/OrdersPageBase";
import { BASE_URLS } from "../config/urls";
import { useAuth } from "../context/AuthContext";

export default function CurrentOrdersPage() {
    const { person } = useAuth();

    return (
        <OrdersPageBase
            title="Ваши активные записи"
            badgeText="Текущие поставки"
            subtitle="Здесь отображаются текущие поставки, статус оплаты и доставки."
            ordersEndpoint={`${BASE_URLS.api}/current_orders`}
            hints={
                <ul className="schedule-side-list">
                    <li>
                        <strong>«Скачать этикетки»</strong> — сформирует PDF 60×40 для каждой коробки.
                    </li>
                    <li>
                        <strong>«Оплатить»</strong> появляется только для онлайн-оплаты, если заказ ещё не оплачен.
                    </li>
                    <li>
                        Удаление и изменение доступно только для заказов, которые ещё не приняты в работу.
                    </li>
                    <li>
                        В <strong>«Просмотр»</strong> можно открыть детали и перейти к редактированию.
                    </li>
                </ul>
            }
            emptyTitle="Нет текущих заказов"
            emptySubtitle="Когда появятся активные записи — они будут здесь."
            allowActions={true}
            person={person}
        />
    );
}
